<template>
  <div class="lesson_drawer">
    <div class="rank_list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="order_list">
            <div class="order_item" v-for="(itee, index) in orderbans" :key="index">
              <div class="oitem_up" @click="goDetails(itee)">
                <van-row>
                  <van-col span="8" class="ban_left">
                    <img :src="itee.icon" alt="图标" />
                  </van-col>
                  <van-col span="16">
                    <div class="oitem_cont">
                      <div>
                        <span class="oitem_head">{{ itee.nick }}</span>
                      </div>
                      <div class="oitem_desc">
                        <img src="@/assets/img/yygs/position.png" alt="" />
                        {{ itee.address }}
                      </div>
                      <div class="oitem_desc" v-if="itee.photo">
                        <img src="@/assets/img/yygs/photo1.png" alt="" />
                        {{ itee.photo }}
                      </div>
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {
  getHotelPage,
  getActivityPage,
  getAttractionsPage,
  getCateringPage,
  getScenicspotPage,
} from "@/services/yygs";

export default {
  name: "venueDrawer",
  components: {},
  props: ["optionsData"],
  computed: {},
  data() {
    return {
      schoolName: this.$route.query.schoolName,
      orderbans: [],
      loading: false,
      finished: false,
      refreshing: false,
      options: {
        city: "",
        county: "",
        current: 0,
        establishmentsId: this.$route.query.id,
        name: "",
        pcc: "",
        province: "",
        size: 4,
        venuesTypeId: "",
      },
    };
  },
  created() {},
  mounted() {
    this.orderbans = [];
  },
  methods: {
    goDetails(info) {
      switch (this.optionsData.type) {
        case "1":
          this.JumpTo("/navlist/placeDetails", {
            id: info.id,
          });
          break;
        case "2":
          this.JumpTo("/navlist/details", {
            id: info.id,
          });
          break;
        case "4":
          this.JumpTo("/navlist/delicacy", {
            id: info.id,
          });
          break;
        default:
          this.JumpTo("/navlist/details", {
            id: info.id,
          });
      }
    },
    getData(callback) {
      var optionsData = this.optionsData;
      switch (optionsData?.type) {
        //活动
        case "3": {
          getActivityPage().then((res) => {
            this.getDatas(res, callback);
          });
          break;
        }
        //住宿
        case "2": {
          getHotelPage(this.options).then((res) => {
            this.getDatas(res, callback);
          });
          break;
        }
        // 景区
        case "1": {
          getScenicspotPage(this.options).then((res) => {
            this.getDatas(res, callback);
          });
          break;
        }
        // 餐饮
        case "4": {
          getCateringPage(this.options).then((res) => {
            this.getDatas(res, callback);
          });
          break;
        }
        // 城市地标
        case "5": {
          getAttractionsPage(this.options).then((res) => {
            this.getDatas(res, callback);
          });
          break;
        }
      }
    },
    getDatas(res, callback) {
      if (res && res.code === 200) {
        console.log(res.data, 888);

        res.data.records.forEach((element) => {
          const obj = Object.assign(element, {
            typee: "2",
            nick: element.name,
            address: element.position,
            photo: element.contactPhone,
            icon: element.logo,
          });
          this.orderbans.push(obj);
        });
      }
      if (callback) {
        callback(res?.data);
      }
    },
    onLoad() {
      setTimeout(() => {
        this.options.current = this.orderbans.length / this.options.size + 1;
        this.getData((resData) => {
          if (this.refreshing) {
            this.orderbans = [];
            this.refreshing = false;
          }
          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.orderbans.length >= resData.total) {
            this.finished = true;
          }
        });
      }, 100);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style lang="scss" scoped>
.lesson_drawer {
  width: 100%;
  min-height: 100vh;
  background: #eeeeee;
  padding-top: 0.5rem;
  // background: #fff url("~@/assets/img/bg_news.jpg") no-repeat center top/100%;
  box-sizing: border-box;
  text-align: justify;
  padding-bottom: 1rem;
}

.draw_title {
  padding: 0.6rem 0 0.3rem;
  font-size: 0.36rem;
  text-align: center;
  font-weight: bold;
  padding-top: 1rem;
}
.van-row {
}
.order_list {
  width: 90%;
  margin: 0 auto;
  max-width: 9rem;
}
.oitem_desc {
  display: flex;
  align-items: center;
  img {
    border: none;
    width: 0.25rem;
    margin-right: 0.1rem;
  }
}

.oitem_head {
  height: 0.38rem !important;
  margin-bottom: 0 !important;
}
</style>
